
const ColorField = ({ label, value, onChange }) => {
  return (
    <div className="col-12 col-md-6 col-lg-4 col-xl-3">
      <label className="form-label fw-medium text-dark mb-2">
        {label.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
      </label>

      <div className="d-flex align-items-center gap-3">
        <input
          type="color"
          className="form-control form-control-color shadow-sm"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />

        <input
          type="text"
          className="form-control shadow-sm"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{ minWidth: "120px" }}
        />
      </div>
    </div>
  );
};


const CustomThemeEditor = ({ customTheme, onChange }) => {
  const colorGroups = [
    {
      title: "Primary Colors",
      colors: [
        "color-primary-dark",
        "color-primary-light",
        "color-accent-yellow",
        "graph-open-col-fill",
      ],
    },
    {
      title: "Header Colors",
      colors: ["header-bg-start", "header-bg-end", "header-border-color"],
    },
    {
      title: "Sidebar Colors",
      colors: [
        "sidebar-bg-start",
        "sidebar-bg-end",
        "sidebar-text-color",
        "sidebar-icon-color",
        "sidebar-active-bg",
        "sidebar-active-text-color",
        "sidebar-scrollbar-thumb-color",
        "sidebar-scrollbar-track-color",
      ],
    },
    {
      title: "Component Colors",
      colors: [
        "location-switcher-bg",
        "location-switcher-text-color",
        "location-switcher-icon-color",
        "sidebar-action-button-bg",
        "sidebar-action-button-text-color",
        "card-bg-color",
        "card-border-color",
        "button-bg-color",
        "button-border-color",
        "button-text-color",
        "button-hover-bg",
        "button-hover-text-color",
      ],
    },
    {
      title: "Utility Colors",
      colors: ["scrollbar-thumb-color", "card-shadow"],
    },
  ];

  return (
    <div className="card shadow-sm border-0 rounded-4 p-4 mb-5">
      <h5 className="fw-semibold mb-4">Custom Theme Colors</h5>

      <div className="row g-4">
        {colorGroups.map((group, idx) => (
          <div key={idx} className="col-12">
            <h6 className="fw-semibold text-dark mb-3 border-bottom pb-2">
              {group.title}
            </h6>

            <div className="row g-4">
              {group.colors.map((colorKey) => (
                <ColorField
                  key={colorKey}
                  label={colorKey}
                  value={customTheme[`--${colorKey}`]}
                  onChange={(value) => onChange(`--${colorKey}`, value)}
                />
              ))}
            </div>

            {idx < colorGroups.length - 1 && <hr className="my-4" />}
          </div>
        ))}
      </div>
  </div>
  );
};

export default CustomThemeEditor;